import axios from 'axios';
import { message } from 'antd';
import { decrypt } from './index';

const resFormat = data => (data.encryptData ? ({ ...data, result: decrypt(data.encryptData )}) : data) || {};
/**
 * get方法，对应get请求
 * @param {String} url [请求的url地址]
 * @param {Object} params [请求时携带的参数]
 */
export function get(url, params = {}, headers = {}, config = {}) {
  return new Promise((resolve, reject) => {
    axios.get(url, {
      params,
      headers,
      ...config
    }).then((response) => {
      if (response.data.errCode === 0) {
        resolve(resFormat(response.data));
        return;
      };
      message.error(response.data.errInfo)
      reject({ ...response.data, message: response.data.errInfo});
    }).catch((err) => {
      message.error(err.message)
      reject(err);
    });
  });
}

/**
 * post请求
 * @param {String} url [请求的url地址]
 * @param {Object} params [请求携带的参数]
 * @param {Object} headers [请求的headers参数]
 */
export function post(url, params = {}, headers = {}, config = {}) {
    return new Promise((resolve, reject) => {
        axios
            .post(url, params, {
                headers,
                ...config
            })
            .then((response) => {
                if (headers.ArrayBuffer) {
                    resolve(response) ;
                    return
                }
                if (response.data.errCode === 0) {
                    resolve(resFormat(response.data));
                    return;
                }
                if (typeof response.data.errInfo === 'string') {
                  message.error(response.data.errInfo || response.data.errMsg);
                } else {
                  // message.error(response.data.errInfo || response.data.errMsg);
                }
                reject({  ...response.data, message: response.data.errInfo || response.data.errMsg });
            })
            .catch((err) => {
                message.error(err.message);
                reject(err);
            });
    });
}

/**
 * put请求
 * @param {String} url [请求的url地址]
 * @param {Object} params [请求携带的参数]
 * @param {Object} headers [请求的headers参数]
 */
export function put(url, params, headers = {}) {
  return new Promise((resolve, reject) => {
    axios.put(url, params, {
      headers
    }).then(response => {
      if (response.data.errCode === 0) {
        resolve(resFormat(response.data));
        return;
      };
      message.error(response.data.errInfo)
      reject({ ...response.data, message: response.data.errInfo });
    }).catch((err) => {
      message.error(err.message)
      reject(err);
    });
  });
}

/**
 * delete请求
 * @param {String} url [请求的url地址]
 * @param {Object} params [请求携带的参数]
 */
export function del(url, params = {}, headers = {}) {
  return new Promise((resolve, reject) => {
    axios({
      method: 'DELETE',
      headers,
      data: params,
      url,
    }).then(response => {
      if (response.data.errCode === 0) {
        resolve(resFormat(response.data));
        return;
      }
      message.error(response.data.errInfo)
      reject({ ...response.data, message: response.data.errInfo });
    }).catch((err) => {
      message.error(err.message)
      reject(err);
    });
  });
}
